import React from 'react';
import Head from 'next/head';
import NewLanding from '../../components/NewLanding/NewLanding';
import Script from 'next/script';

const NewLandingPageFolderBased = () => {
  return (
    <>
      <Head>
        <title>Zenyai | Collaborative Workspace for Game Audio Teams</title>
        <meta name="description" content="Zenyai is the pre-production workspace where sound designers and devs co-create audio" />
      </Head>
      <NewLanding />
      <Script
        id="intercom-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.intercomSettings = {
              app_id: "jshki9xs",
              hide_default_launcher: false,
              custom_launcher_selector: '#intercom-launcher',
              welcome_message: {
                type: 'text',
                text: 'Hi there 👋'
              },
              messenger: {
                welcome_message: {
                  type: 'text',
                  text: 'Hi there 👋'
                }
              }
            };
            (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/jshki9xs';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
          `
        }}
      />
    </>
  );
};

export default NewLandingPageFolderBased; 